<template>
  <zt-modal
    class="rounded font-normal"
    max-width="600px"
    :title="$t('message.certificates.modal.title')"
    :active="active"
    :z-index="1001"
    @close="closeDialog"
  >
    <template>
      <div class="mb-4 px-10 py-12">
        <div class="flex items-center">
          <div class="flex-none flex items-center w-24 h-24">
            <zt-icon
              name="exclamation-circle-outline"
              class="text-zt-warning"
              :style="{ fontSize: '4rem'}"
            />
          </div>
          <div>
            <p class="lg:text-zt-xl text-zt-dark-500">
              {{ $t('message.certificates.modal.downloadItem', { item: certificate.text }) }}
            </p>
          </div>
        </div>
      </div>
      <div v-if="shownError" class="flex flex-col items-center lg:flex-row px-10 pb-12">
        <zt-alert :color="status" close-icon filled class="modal-message" @afterClosed="hideMessage">
          <div slot="custom-content">
            <div class="flex justify-start items-center p-2">
              <zt-icon v-if="iconName" :name="iconName" class="icon mr-2"></zt-icon>
              <p>{{ message }}</p>
            </div>
          </div>
        </zt-alert>
      </div>
    </template>
    <template #modal-footer>
      <div
        class="zt-modal-footer rounded-b flex justify-end items-center p-4"
      >
        <zt-button
          text
          color="dark-300"
          class="button-cancel mr-4"
          @click="closeDialog"
          data-vs-button="certificates-download-btn-closedialog"
        >
          {{ $t('message.certificates.modal.cancel') }}
        </zt-button>
        <zt-button class="w-25" :disabled="isActive" :loader="downloading" @click="download" data-vs-button="certificates-download-btn-activedownload">
          {{ $t('message.certificates.modal.download') }}
        </zt-button>
      </div>
    </template>
  </zt-modal>
</template>

<script>
import { isEmpty } from 'lodash'
import Users from '@/apiClient/Users'
const icons = {
  'danger': 'exclamation-circle-solid',
  'warning': 'warning-circle-solid',
  'info': 'info-circle-solid'
}
export default {
  name: 'DownloadCertificatesDialog',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => ({})
    }
  },
  inject: [ 'openDownloadDialog' ],
  data() {
    return {
      downloading: false,
      downloadActive: false,
      certificate: {},
      shownError: false,
      message: '',
      status: 'danger'
    }
  },
  watch: {
    item(value) {
      if (value) {
        this.certificate = {
          text: value.name_certificate,
          value: value.id
        }
      }
    }
  },
  computed: {
    isActive() {
      return isEmpty(this.certificate)
    },
    iconName() {
      return icons[this.status]
    }
  },
  created() {
    if (!this.usersApi) this.usersApi = new Users()
  },
  methods: {
    closeDialog() {
      if (this.downloading) return
      this.openDownloadDialog(false)
      this.certificate = {}
      this.hideMessage()
    },
    async download() {
      try {
        this.downloading = true
        const { data: { data }} = await this.usersApi.getCertRequestedHistory(this.certificate.value)
        const element = document.createElement('a')
        element.href = `${data.link}`
        element.click()
        this.downloading = false
        this.closeDialog()
      } catch (e) {
        console.log(e)
        this.downloading = false
        if (e.response && e.response.status === 404) {
          this.message = this.$t('message.certificates.error.download')
          this.status = 'danger'
          this.shownError = true
        }
      }
    },
    hideMessage() {
      this.shownError = false
    }
  }
}
</script>

<style scoped lang="scss">
.zt-modal-footer {
  background-color: #EEEEEE;
}
::v-deep {
  .zt-modal {
    box-shadow: 0 3px 4px rgba(0, 0, 0, 0.14), 0 3px 3px rgba(0, 0, 0, 0.12),
    0 1px 8px rgba(0, 0, 0, 0.2);
  }
  .zt-modal.rounded {
    border-radius: .375rem!important;
  }
  button.button-cancel {
    color: #707070!important;
    background-color: transparent!important;
  }
  .zt-icon-times {
    margin-top: 7px;
  }
  .icon {
    font-size: 2rem;
  }
  .modal-message {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }
}

</style>
